import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Filter chip values for the DeliveryNote orderType column (R8).
 *
 * - null  → show all (no filter)
 * - REGULAR → existing B2B
 * - CONSIGNMENT_* → consignment flows
 */
export type OrderTypeFilterValue =
  | "REGULAR"
  | "CONSIGNMENT_INITIAL"
  | "CONSIGNMENT_REPLENISHMENT"
  | "CONSIGNMENT_RETURN"
  | "CONSIGNMENT_TRANSFER"
  | null;

const PARAM_NAME = "orderType";

export function useOrderTypeFilter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get(PARAM_NAME);
  const value = (raw as OrderTypeFilterValue) ?? null;

  const setValue = useCallback(
    (next: OrderTypeFilterValue) => {
      const updated = new URLSearchParams(searchParams);
      if (next) {
        updated.set(PARAM_NAME, next);
      } else {
        updated.delete(PARAM_NAME);
      }
      setSearchParams(updated, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return { value, setValue };
}
